tinymce.addI18n("hr", {
    "#": "#",
    "Accessibility": "Pristupa\u010dnost",
    "Accordion": "",
    "Accordion body...": "",
    "Accordion summary...": "",
    "Action": "Radnja",
    "Activity": "Aktivnosti",
    "Address": "Adresa",
    "Advanced": "Napredne postavke",
    "Align": "Poravnaj",
    "Align center": "Poravnaj po sredini",
    "Align left": "Poravnaj lijevo",
    "Align right": "Poravnaj desno",
    "Alignment": "Poravnanje",
    "Alignment {0}": "",
    "All": "Svi",
    "Alternative description": "Alternativni opis",
    "Alternative source": "Alternativni izvor",
    "Alternative source URL": "URL alternativnog izvora",
    "Anchor": "Sidro",
    "Anchor...": "Sidro...",
    "Anchors": "Sidra",
    "Animals and Nature": "\u017divotinje i priroda",
    "Arrows": "Strelice",
    "B": "B",
    "Background color": "Boja pozadine",
    "Background color {0}": "",
    "Black": "Crna",
    "Block": "Blok",
    "Block {0}": "",
    "Blockquote": "Blockquote",
    "Blocks": "Blokovi",
    "Blue": "Plava",
    "Blue component": "Plava komponenta",
    "Body": "Tijelo",
    "Bold": "Podebljano",
    "Border": "Granica",
    "Border color": "Boja granice",
    "Border style": "Stil granice",
    "Border width": "\u0160irina granice",
    "Bottom": "Dno",
    "Browse files": "",
    "Browse for an image": "Potra\u017eite sliku",
    "Browse links": "",
    "Bullet list": "Popis s oznakama",
    "Cancel": "Odustani",
    "Caption": "Naslov",
    "Cell": "\u0106elija",
    "Cell padding": "Podloga \u0107elije",
    "Cell properties": "Svojstva \u0107elija",
    "Cell spacing": "Razmak izme\u0111u \u0107elija",
    "Cell styles": "Stilovi \u0107elije",
    "Cell type": "Vrsta \u0107elije",
    "Center": "Sredina",
    "Characters": "Znakovi",
    "Characters (no spaces)": "Znakovi (bez razmaka)",
    "Circle": "Krug",
    "Class": "Klasa",
    "Clear formatting": "Izbri\u0161i oblikovanje",
    "Close": "Zatvori",
    "Code": "Kod",
    "Code sample...": "Primjerak k\xf4da...",
    "Code view": "Pregled koda",
    "Color Picker": "Izabira\u010d boja",
    "Color swatch": "Uzorak boje",
    "Cols": "Stupci",
    "Column": "Stupac",
    "Column clipboard actions": "Akcije me\u0111uspremnika za stupac",
    "Column group": "Grupa stupaca",
    "Column header": "Zaglavlje stupca",
    "Constrain proportions": "Ograni\u010di omjere",
    "Copy": "Kopiraj",
    "Copy column": "Kopiraj stupac",
    "Copy row": "Kopiraj redak",
    "Could not find the specified string.": "Nije bilo mogu\u0107e prona\u0107i navedeni niz.",
    "Could not load emojis": "Nije mogu\u0107e u\u010ditati emotikone",
    "Count": "Broj",
    "Currency": "Valuta",
    "Current window": "Trenuta\u010dni prozor",
    "Custom color": "Prilago\u0111ena boja",
    "Custom...": "Prilago\u0111eno...",
    "Cut": "Izre\u017ei",
    "Cut column": "Izre\u017ei stupac",
    "Cut row": "Izre\u017ei redak",
    "Dark Blue": "Tamnoplava",
    "Dark Gray": "Tamnosiva",
    "Dark Green": "Tamnozelena",
    "Dark Orange": "Tamnonaran\u010dasta",
    "Dark Purple": "Tamnoljubi\u010dasta",
    "Dark Red": "Tamnocrvena",
    "Dark Turquoise": "Tamnotirkizna",
    "Dark Yellow": "Tamno\u017euta",
    "Dashed": "Crtkani",
    "Date/time": "Datum/vrijeme",
    "Decrease indent": "Smanji uvla\u010denje",
    "Default": "Standardna vrijednost",
    "Delete accordion": "",
    "Delete column": "Izbri\u0161i stupac",
    "Delete row": "Izbri\u0161i redak",
    "Delete table": "Izbri\u0161i tablicu",
    "Dimensions": "Mjere",
    "Disc": "Disk",
    "Div": "Div",
    "Document": "Dokument",
    "Dotted": "To\u010dkasti",
    "Double": "Dupli",
    "Drop an image here": "Ispustite sliku ovdje",
    "Dropped file type is not supported": "Dodana datoteka nije podr\u017eana",
    "Edit": "Uredi",
    "Embed": "Ugradi",
    "Emojis": "Emotikoni",
    "Emojis...": "Emotikoni...",
    "Error": "Pogre\u0161ka",
    "Error: Form submit field collision.": "Pogre\u0161ka: sukob polja za podno\u0161enje obrasca.",
    "Error: No form element found.": "Pogre\u0161ka: nema elementa oblika.",
    "Extended Latin": "Pro\u0161ireni latinski",
    "Failed to initialize plugin: {0}": "Pokretanje dodatka nije uspjelo: {0}",
    "Failed to load plugin url: {0}": "U\u010ditavanje dodatka nije uspjelo: {0}",
    "Failed to load plugin: {0} from url {1}": "U\u010ditavanje dodatka nije uspjelo: {0} s URL-a {1}",
    "Failed to upload image: {0}": "U\u010ditavanje slike nije uspjelo: {0}",
    "File": "Datoteka",
    "Find": "Na\u0111i",
    "Find (if searchreplace plugin activated)": "Prona\u0111i (ako je dodatak za tra\u017eenje i zamjenjivanje aktiviran)",
    "Find and Replace": "Prona\u0111i i izmjeni",
    "Find and replace...": "Prona\u0111i i zamijeni...",
    "Find in selection": "Prona\u0111i u selekciji",
    "Find whole words only": "Prona\u0111i samo cijele rije\u010di",
    "Flags": "Zastave",
    "Focus to contextual toolbar": "Fokus na kontekstnu alatnu traku",
    "Focus to element path": "Fokus na put elementa",
    "Focus to menubar": "Fokus na traku izbornika",
    "Focus to toolbar": "Fokus na alatnu traku",
    "Font": "Font",
    "Font size {0}": "",
    "Font sizes": "Veli\u010dine fonta",
    "Font {0}": "",
    "Fonts": "Fontovi",
    "Food and Drink": "Hrana i pi\u0107e",
    "Footer": "Podno\u017eje",
    "Format": "Oblikovanje",
    "Format {0}": "",
    "Formats": "Formati",
    "Fullscreen": "Cijeli zaslon",
    "G": "G",
    "General": "Op\u0107e postavke",
    "Gray": "Siva",
    "Green": "Zelena",
    "Green component": "Zelena komponenta",
    "Groove": "Brazda",
    "Handy Shortcuts": "Korisni pre\u010daci",
    "Header": "Zaglavlje",
    "Header cell": "\u0106elija zaglavlja",
    "Heading 1": "Zaglavlje 1",
    "Heading 2": "Zaglavlje 2",
    "Heading 3": "Zaglavlje 3",
    "Heading 4": "Zaglavlje 4",
    "Heading 5": "Zaglavlje 5",
    "Heading 6": "Zaglavlje 6",
    "Headings": "Zaglavlja",
    "Height": "Visina",
    "Help": "Pomo\u0107",
    "Hex color code": "Hex kod boje",
    "Hidden": "Skriven",
    "Horizontal align": "Horizontalno poravnanje",
    "Horizontal line": "Vodoravna crta",
    "Horizontal space": "Vodoravni prostor",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID treba po\u010dinjati sa slovom, te sadr\u017eavati samo slova, brojeve, povlake, to\u010dke, dvoto\u010dke i donje crte.",
    "Image is decorative": "Fotografija je dekorativna",
    "Image list": "Popis slika",
    "Image title": "Naslov slike",
    "Image...": "Slika...",
    "ImageProxy HTTP error: Could not find Image Proxy": "",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "",
    "ImageProxy HTTP error: Rejected request": "",
    "ImageProxy HTTP error: Unknown ImageProxy error": "",
    "Increase indent": "Pove\u0107aj uvla\u010denje",
    "Inline": "U retku",
    "Insert": "Umetni",
    "Insert Template": "Umetni predlo\u017eak",
    "Insert accordion": "",
    "Insert column after": "Umetni stupac iza",
    "Insert column before": "Umetni stupac ispred",
    "Insert date/time": "Umetni datum/vrijeme",
    "Insert image": "Umetni sliku",
    "Insert link (if link plugin activated)": "Umetni poveznicu (ako je dodatak za povezivanje aktiviran)",
    "Insert row after": "Umetni redak iza",
    "Insert row before": "Umetni redak ispred",
    "Insert table": "Umetni tablicu",
    "Insert template...": "Umetni predlo\u017eak...",
    "Insert video": "Umetni videozapis",
    "Insert/Edit code sample": "Umetni/uredi primjerak k\xf4da",
    "Insert/edit image": "Umetni/izmijeni sliku",
    "Insert/edit link": "Umetni/uredi poveznicu",
    "Insert/edit media": "Umetni/uredi medije",
    "Insert/edit video": "Umetni/uredi videozapis",
    "Inset": "Udubljenje",
    "Invalid hex color code: {0}": "Neispravan hex kod boje: {0}",
    "Invalid input": "Neispravan unos",
    "Italic": "Kurziv",
    "Justify": "Obostrano poravnanje",
    "Keyboard Navigation": "Navigacija na tipkovnici",
    "Language": "Jezik",
    "Learn more...": "Saznajte vi\u0161e...",
    "Left": "Lijevo",
    "Left to right": "Slijeva nadesno",
    "Light Blue": "Svjetloplava",
    "Light Gray": "Svijetlosiva",
    "Light Green": "Svjetlozelena",
    "Light Purple": "Svjetloljubi\u010dasta",
    "Light Red": "Svjetlocrvena",
    "Light Yellow": "Svjetlo\u017euta",
    "Line height": "Visina reda",
    "Link list": "Popis poveznica",
    "Link...": "Poveznica...",
    "List Properties": "Svojstva liste",
    "List properties...": "Svojstva liste...",
    "Loading emojis...": "U\u010ditavanje emotikona...",
    "Loading...": "U\u010ditavanje...",
    "Lower Alpha": "Mala slova",
    "Lower Greek": "Mala gr\u010dka slova",
    "Lower Roman": "Male rimske znamenke",
    "Match case": "Prilagodi slova",
    "Mathematical": "Matemati\u010dki",
    "Media poster (Image URL)": "Medijski poster (URL slike)",
    "Media...": "Mediji...",
    "Medium Blue": "Srednje plava",
    "Medium Gray": "Srednje siva",
    "Medium Purple": "Srednje ljubi\u010dasta",
    "Merge cells": "Spoji \u0107elije",
    "Middle": "Sredina",
    "Midnight Blue": "Pono\u0107no plava",
    "More...": "Vi\u0161e...",
    "Name": "Ime",
    "Navy Blue": "Mornarsko plava",
    "New document": "Novi dokument",
    "New window": "Novi prozor",
    "Next": "Sljede\u0107e",
    "No": "Ne",
    "No alignment": "Bez poravnavanja",
    "No color": "Bez boje",
    "Nonbreaking space": "Nerastavljaju\u0107i razmak",
    "None": "Nema",
    "Numbered list": "Numerirani popis",
    "OR": "ILI",
    "Objects": "Predmeti",
    "Ok": "U redu",
    "Open help dialog": "Otvori dijalo\u0161ki okvir za pomo\u0107",
    "Open link": "Otvori poveznicu",
    "Open link in...": "Otvori poveznicu u...",
    "Open popup menu for split buttons": "Otvori padaju\u0107i izbornik na podijeljenim gumbima",
    "Orange": "Naran\u010dasta",
    "Outset": "Ispup\u010denje",
    "Page break": "Prijelom stranice",
    "Paragraph": "Odlomak",
    "Paste": "Zalijepi",
    "Paste as text": "Zalijepi kao tekst",
    "Paste column after": "Zalijepi stupac iza",
    "Paste column before": "Zalijepi stupac ispred",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Radnjom lijepljenja od sada se lijepi obi\u010dan tekst. Sadr\u017eaj \u0107e se lijepiti kao obi\u010dan tekst sve dok ne isklju\u010dite ovu opciju.",
    "Paste or type a link": "Zalijepite ili upi\u0161ite poveznicu",
    "Paste row after": "Zalijepi redak iza",
    "Paste row before": "Zalijepi redak ispred",
    "Paste your embed code below:": "Zalijepite k\xf4d za ugradnju u nastavku:",
    "People": "Osobe",
    "Plugins": "Dodaci",
    "Plugins installed ({0}):": "Instalirani dodaci ({0}):",
    "Powered by {0}": "Omogu\u0107uje {0}",
    "Pre": "Pre",
    "Preferences": "Postavke",
    "Preformatted": "Prethodno oblikovano",
    "Premium plugins:": "Premium dodaci:",
    "Press the Up and Down arrow keys to resize the editor.": "",
    "Press the arrow keys to resize the editor.": "Pritisnite strelice za promjenu veli\u010dine ure\u0111iva\u010da.",
    "Press {0} for help": "",
    "Preview": "Pretpregled",
    "Previous": "Prethodno",
    "Print": "Ispi\u0161i",
    "Print...": "Ispi\u0161i...",
    "Purple": "Ljubi\u010dasta",
    "Quotations": "Navodnici",
    "R": "R",
    "Range 0 to 255": "Raspon 0 do 255",
    "Red": "Crvena",
    "Red component": "Crvena komponenta",
    "Redo": "Ponovi",
    "Remove": "Ukloni",
    "Remove color": "Ukloni boju",
    "Remove link": "Ukloni poveznicu",
    "Replace": "Zamijeni",
    "Replace all": "Zamijeni sve",
    "Replace with": "Zamijeni s",
    "Resize": "Promijeni veli\u010dinu",
    "Restore last draft": "Vrati posljednju skicu",
    "Reveal or hide additional toolbar items": "",
    "Rich Text Area": "Podru\u010dje oboga\u0107enog teksta",
    "Rich Text Area. Press ALT-0 for help.": "Podru\u010dje oboga\u0107enog teksta. Pritisnite ALT-0 za pomo\u0107.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Podru\u010dje oboga\u0107enog teksta. Pritisnite ALT-F9 za izbornik. Pritisnite ALT-F10 za alatnu traku. Pritisnite ALT-0 za pomo\u0107",
    "Ridge": "Izbo\u010denje",
    "Right": "Desno",
    "Right to left": "Zdesna ulijevo",
    "Row": "Redak",
    "Row clipboard actions": "Akcije me\u0111uspremnika za redak",
    "Row group": "Grupa redaka",
    "Row header": "Zaglavlje retka",
    "Row properties": "Svojstva retka",
    "Row type": "Vrsta retka",
    "Rows": "Redovi",
    "Save": "Spremi",
    "Save (if save plugin activated)": "Spremi (ako je dodatak za spremanje aktiviran)",
    "Scope": "Podru\u010dje va\u017eenja",
    "Search": "Tra\u017ei",
    "Select all": "Odaberi sve",
    "Select...": "Odaberi...",
    "Selection": "Odabir",
    "Shortcut": "Pre\u010dac",
    "Show blocks": "Prika\u017ei blokove",
    "Show caption": "Prika\u017ei naslov",
    "Show invisible characters": "Prika\u017ei nevidljive znakove",
    "Size": "Veli\u010dina",
    "Solid": "Puni",
    "Source": "Izvor",
    "Source code": "Izvorni k\xf4d",
    "Special Character": "Poseban znak",
    "Special character...": "Poseban znak...",
    "Split cell": "Razdvoji \u0107elije",
    "Square": "Kvadrat",
    "Start list at number": "Kreni listu s brojem",
    "Strikethrough": "Prekri\u017ei",
    "Style": "Format",
    "Subscript": "Indeks",
    "Superscript": "Eksponent",
    "Switch to or from fullscreen mode": "Prebacivanje u prikaz preko cijelog zaslona ili iz njega",
    "Symbols": "Simboli",
    "System Font": "Font sustava",
    "Table": "Tablica",
    "Table caption": "Naslov tablice",
    "Table properties": "Svojstva tablice",
    "Table styles": "Stilovi tablice",
    "Template": "Predlo\u017eak",
    "Templates": "Predlo\u0161ci",
    "Text": "Tekst",
    "Text color": "Boja teksta",
    "Text color {0}": "",
    "Text to display": "Tekst za prikaz",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Izgleda da je URL koji ste upisali adresa e-po\u0161te. \u017delite li dodati obavezan prefiks mailto:?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Izgleda da je URL koji ste upisali vanjska poveznica. \u017delite li dodati obavezan prefiks http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Izgleda da je URL koji ste upisali vanjska poveznica. \u017delite li dodati obavezan prefiks https://?",
    "Title": "Naslov",
    "To open the popup, press Shift+Enter": "Da biste otvorili sko\u010dni prozor, pritisnite Shift\xa0+\xa0Enter",
    "Toggle accordion": "",
    "Tools": "Alati",
    "Top": "Vrh",
    "Travel and Places": "Putovanje i mjesta",
    "Turquoise": "Tirkizna",
    "Underline": "Podcrtaj",
    "Undo": "Poni\u0161ti",
    "Upload": "U\u010ditaj",
    "Uploading image": "U\u010ditavanje fotografije",
    "Upper Alpha": "Velika slova",
    "Upper Roman": "Velike rimske znamenke",
    "Url": "URL",
    "User Defined": "Korisni\u010dki definirano",
    "Valid": "Valjano",
    "Version": "Ina\u010dica",
    "Vertical align": "Vertikalno poravnanje",
    "Vertical space": "Uspravni prostor",
    "View": "Prikaz",
    "Visual aids": "Vizualna pomo\u0107",
    "Warn": "Upozori",
    "White": "Bijela",
    "Width": "\u0160irina",
    "Word count": "Broj rije\u010di",
    "Words": "Rije\u010di",
    "Words: {0}": "Rije\u010di: {0}",
    "Yellow": "\u017duta",
    "Yes": "Da",
    "You are using {0}": "Upotrebljavate {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Imate nepohranjene izmjene, jeste li sigurni da \u017eelite oti\u0107i?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Va\u0161 preglednik ne podr\u017eava izravan pristup me\u0111uspremniku. Umjesto toga upotrijebite tipkovni\u010dke pre\u010dace Ctrl\xa0+\xa0X/C/V.",
    "alignment": "poravnanje",
    "austral sign": "znak za austral",
    "cedi sign": "znak za cedi",
    "colon sign": "znak za kolon",
    "cruzeiro sign": "znak za cruzeiro",
    "currency sign": "znak za valutu",
    "dollar sign": "znak za dolar",
    "dong sign": "znak za dong",
    "drachma sign": "znak za drahmu",
    "euro-currency sign": "znak za valutu \u2013 euro",
    "example": "primjer",
    "formatting": "oblikovanje",
    "french franc sign": "znak za francuski franak",
    "german penny symbol": "simbol za njema\u010dki peni",
    "guarani sign": "znak za gvarani",
    "history": "povijest",
    "hryvnia sign": "znak za grivnju",
    "indentation": "uvlaka",
    "indian rupee sign": "znak za indijsku rupiju",
    "kip sign": "znak za kip",
    "lira sign": "znak za liru",
    "livre tournois sign": "znak za livre tournois",
    "manat sign": "znak za manat",
    "mill sign": "znak za mill",
    "naira sign": "znak za nairu",
    "new sheqel sign": "znak za novi \u0161ekel",
    "nordic mark sign": "znak za nordijsku marku",
    "peseta sign": "znak za pezetu",
    "peso sign": "znak za pezo",
    "ruble sign": "znak za rubalj",
    "rupee sign": "znak za rupiju",
    "spesmilo sign": "znak za spesmilo",
    "styles": "stilovi",
    "tenge sign": "znak za tengu",
    "tugrik sign": "znak za tugrik",
    "turkish lira sign": "znak za tursku liru",
    "won sign": "znak za von",
    "yen character": "znak za jen",
    "yen/yuan character variant one": "znak za jen/juan, prva varijanta",
    "yuan character": "znak za juan",
    "yuan character, in hong kong and taiwan": "znak za juan, u Hong Kongu i Tajvanu",
    "{0} characters": "{0} znakova",
    "{0} columns, {1} rows": "",
    "{0} words": "{0} rije\u010d(i)"
});